import { Component, OnInit, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import * as sweetalert from 'sweetalert';
import { Sort } from '@angular/material';
import { UUID } from 'angular2-uuid';
//grid
import { AgGridNg2 } from 'ag-grid-angular';
import { GridApi, GridOptions } from 'ag-grid';

import { TipoMedicionBO } from '../Models/TipoMedicionBO';

import { MedicionService } from '../services/medicion.service';
import { GlobalsService } from '../services/globals.service';
@Component({
  selector: 'app-medicion',
  templateUrl: './medicion.component.html',
  styleUrls: ['./medicion.component.css']
})
export class MedicionComponent implements OnInit {

  public medicion: TipoMedicionBO = new TipoMedicionBO();
  public mediciones: TipoMedicionBO[];

  public modoEdicion: boolean = false;
  public nuevoRegistro: boolean = false;

  public actualizarCheckBox: boolean = false;

  @ViewChild('agGrid') agGrid: AgGridNg2;
  title = 'Medicion';

  columnDefs = [
    { headerName: 'Descrpción', field: 'descripcion', icons: { filter: ' ' } },
    { headerName: 'Valor Logico', field: 'valorLogico', icons: { filter: ' ' } },
    { headerName: 'Estado', field: 'estado', icons: { filter: ' ' } },

  ];
  rowData: any[];

  constructor(private medicionService: MedicionService, private globalServices: GlobalsService) {
  }

  ngOnInit() {
    this.CargarMediciones();
  }

  GuardarRegistro() {

    this.medicion.idcompania = this.globalServices.ObtenerCompania();

    if(this.medicion.idMedicion===undefined){
      this.medicion.idMedicion=  UUID.UUID();
    }


    this.medicion.valorLogico=this.actualizarCheckBox;
    this.medicionService.GuardarRegistro(this.medicion).subscribe(

      result => {

        swal("Registro guardado con éxito!", "", "success");

        this.medicion = new TipoMedicionBO();
        this.modoEdicion = false;

        this.CargarMediciones();
      
      },
      err => {
        console.log(err._body);
      });


  }


  CargarMediciones() {
    try {

      this.medicionService.ObtenerMediciones(this.globalServices.ObtenerCompania()).subscribe(
        data => {
          this.mediciones = data;
          this.rowData = this.mediciones;
        },
        err => {
          console.clear();
          console.log(err._body);

        });

    } catch (error) {
      console.log("CargarMediciones:" + error);
    }
  }
  NuevoRegistro() {
    this.nuevoRegistro = true;
    this.medicion = new TipoMedicionBO();
    this.modoEdicion = true;
    this.actualizarCheckBox=false;
  }

    //click en el row de la tabla
    private onCellClicked($event) {

      console.log('onCellClicked: ' + $event.rowIndex + ' ' + $event.colDef.field);
      let row = $event.rowIndex;
      let datos = JSON.parse(JSON.stringify($event.data));
  

      this.nuevoRegistro = false;
      this.medicion = datos;
      this.actualizarCheckBox=this.medicion.valorLogico;
      this.modoEdicion = true;
  
    }
    CancelarEdicion() {
      this.medicion = new TipoMedicionBO();
      this.modoEdicion = false;
     
    }
}
